// app/utils/helpers/gxFormatDateTime.ts
export const gxFormatDateTime = (isoDate?: string): string | undefined => {
  if (!isoDate) return undefined;

  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return isoDate;

  const datePart = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
  });

  const timePart = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${datePart} · ${timePart}`;
};
